import {
  SET_NOTIFICATIONS,
  SET_IN_APP_NOTIFICATIONS,
} from './types';
import { SetRegValueHelper, SpreadOps } from '../helper';

const initialState = {
  list: [],
  count: 0,

  inAppNotifications: {
    list: [],
    count: 0,
  },
};

var temp = "";
initialState.values = SpreadOps({ ...initialState.default });

export default function (state = initialState, action) {
  switch (action.type) {

    case SET_NOTIFICATIONS:
      return {
        ...state,
        list: action.data.list,
        count: action.data.count,
      }

    case SET_IN_APP_NOTIFICATIONS:
      return {
        ...state,
        inAppNotifications: {
          list: action.data.list,
          count: action.data.count,
        }
      }

    default:
      return state

  }
}
